/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Target_Bitrate_LabelInputs */



/**
* | output |
* | --- |
* | "Target Bitrate (kilobits)" |
*
* @param {Drastic_Tech_Target_Bitrate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_target_bitrate_label = /** @type {((inputs?: Drastic_Tech_Target_Bitrate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Target_Bitrate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Debit cible (kilobits)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziel-Bitrate (Kilobit)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bitrate di destinazione (kilobit)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевой битрейт (килобиты)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tasa de bits objetivo (kilobits)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标比特率（千比特）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットビットレート（キロビット）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य बिटरेट (किलोबिट)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de bits alvo (quilobits)")
	return /** @type {LocalizedString} */ ("Target Bitrate (kilobits)")
});